import React from "react";
import { onUserSignUpByStep } from "actions/signup";
import { useSelector } from "react-redux";
import NextButton from "../NextButton";
import { XIcon } from "lucide-react";

// Review Sections
import ReviewApplicant from "./ReviewApplicant";
import ReviewAgency from "./ReviewAgency";
import ReviewAffiliate from "./ReviewAffiliateReferral";

const Review = ({ onChange, formData, nextStep, prevStep, goToStep }) => {
  const [_, setHasError] = React.useState(false);
  const reviewHasError = useSelector(
    (state) => state.signup.reviewHasError || null
  );
  const signupData = useSelector((state) => state.signup.rewardsUser || null);

  const blockSubmit = () => setHasError(true);

  const shouldDisableNextButton = () => {
    if (
      reviewHasError?.birthday ||
      reviewHasError?.display_name ||
      reviewHasError?.first_name ||
      reviewHasError?.last_name ||
      reviewHasError?.phone ||
      (reviewHasError?.manager_represented &&
        (reviewHasError?.manager_name || reviewHasError?.manager_email)) ||
      !signupData?.social_channels?.length
    ) {
      return true;
    }
    return false;
  };

  // Tracking function
  function handleSubmitWithTracking(event) {
    // Call tracking functions defined in the header
    if (typeof fbq === "function") {
      fbq("track", "Creator-Lead");
    }
    if (typeof ttq === "object" && typeof ttq.track === "function") {
      ttq.track("SubmitForm", {
        contents: [
          {
            content_id: "creator_application",
            content_type: "application",
            content_name: "Creator Application Form",
          },
        ],
      });
    }
    // Continue with the next step
    nextStep(event);
  }

  return (
    <div className="mx-auto w-full col-span-full max-w-4xl lg-10 lg:mt-20 px-4 lg:px-0">
      <header className="sticky top-0 py-2 bg-gray-50">
        <div className="relative">
          <h1 className="text-2xl md:text-3xl font-extrabold tracking-tight text-primary-700">
            Review 🔎
          </h1>
          <button
            type="button"
            onClick={prevStep}
            className="border-0 bg-white rounded-full w-8 h-8 flex items-center justify-center absolute right-0 top-1 shadow focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-500 group"
          >
            <XIcon className="h-4 w-4 text-gray-500 group-hover:text-gray-600" />
          </button>
        </div>
      </header>
      <div className="my-10 lg:my-20 w-full">
        <form
          action="#"
          method="POST"
          className="space-y-10 lg:space-y-24 w-full"
        >
          <ReviewApplicant
            onSubmit={onUserSignUpByStep}
            onChange={onChange}
            formData={formData}
            blockSubmit={blockSubmit}
            goToStep={goToStep}
          />
          <ReviewAgency
            onSubmit={onUserSignUpByStep}
            onChange={onChange}
            formData={formData}
            blockSubmit={blockSubmit}
          />
          <ReviewAffiliate
            onSubmit={onUserSignUpByStep}
            onChange={onChange}
            formData={formData}
            blockSubmit={blockSubmit}
          />
          <div className="w-full flex justify-center">
            <NextButton
              id="review-submit-button"
              onClick={handleSubmitWithTracking}
              label="Submit Application"
              disabled={shouldDisableNextButton()}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Review;
